import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useDispatch } from 'react-redux'
import { Grid } from '@mui/material'
import useStylesSeeMoreOrganization from './Styles/useStyleSeeMoreOrganization'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import { getOrganizationWithID } from '../../../../redux/actions/Organizations'
import { traducNameTemporal } from '../../../../utils/traducTypes'

export default function StepperSeeMoreOrganization ({
  setstateSeeMore,
  item,
  setLoading
}) {
  const classes = useStylesSeeMoreOrganization()

  const dispatch = useDispatch()
  const [organization, setOrganization] = useState(null)

  // // get user info request
  const handleGetOrganizationWithID = async () => {
    const response = await dispatch(getOrganizationWithID(item.organizationId))
    if (response) {
      setOrganization(response)
    }
  }
  // get organinzation details of reducer
  useEffect(async () => {
    setLoading(true)
    await handleGetOrganizationWithID()
    setLoading(false)
  }, [])

  // ***
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }

  const SeeMoreOrganizationOfID = ({ item }) => {
    return (
      organization && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Nombre:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationName || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Nombre legal de la organizaci&oacute;n:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationLegalName || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                CUIT de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationCuit || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Tipo de organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {traducNameTemporal(
                  item.organizationType?.organizationTypeCode
                ) || '- -'}{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Máximo de accesos de cuentas:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationMaxAccessCount || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                ID de organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationId || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                Fecha de creación:{' '}
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>Usuario creador: </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.creationUser || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                {' '}
                Fecha de la última modificación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || '- -'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.key}>
                {' '}
                Usuario modificador:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography className={classes.value}>
                {organization.modificationUser || '- -'}
              </Typography>
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            padding: '8px 0px 8px 0px',
            justifyContent: 'space-between',
            boxShadow: '0px 1px 1px #EAEAEA',
            color: '#8C8C8C'
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información de la organización
          </Typography>
          <CloseIcon
            style={{
              cursor: 'pointer',
              paddingRight: 10,
              fontSize: '1.5rem'
            }}
            onClick={() => {
              setstateSeeMore(false)
            }}
          />
        </div>

        <div className={classes.mainBox}>
          <SeeMoreOrganizationOfID item={item} />
        </div>

        <ButtonClose setstateSeeMore={setstateSeeMore} />
      </Box>
    </>
  )
}

function ButtonClose ({ setstateSeeMore }) {
  const classes = useStylesSeeMoreOrganization()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          '&:hover': {
            bgcolor: '#1BF57F'
          }
        }}
        onClick={() => {
          setstateSeeMore(false)
        }}
      >
        <Typography className={classes.closeButtonTypography}>
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
